import { UploadStatus } from '@sc/data-access-models';

export class UploadPartnerStatusUpdateAction {
  static readonly type = '[UploadStatusPartner] Status Update';
  constructor(public payload: UploadStatus) {}
}

export class UploadPartnerStatusInitAction {
  static readonly type = '[UploadStatusPartner] Status Init';
}
